import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=c780ae46&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=c780ae46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c780ae46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c780ae46')) {
      api.createRecord('c780ae46', component.options)
    } else {
      api.reload('c780ae46', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=c780ae46&scoped=true&", function () {
      api.rerender('c780ae46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proprietaire/Documents.vue"
export default component.exports